import multiPickerTemplate from '../../../../../components/assetpicker/asset.multi.picker.html';

export default function ShareAssetsController(
  $filter,
  $uibModal,
  transfersService,
  gettextCatalog,
) {
  'ngInject';
  let vm = this;
  // local scopes variables
  vm.accounts = [];
  vm.equipments = [];
  vm.filteredEquipments = [];
  vm.equipmentsByPage = [];
  vm.errorText = '';
  vm.errorFlag = false;
  vm.loading = true;
  vm.successFlag = false;
  vm.postingData = false;
  vm.accountMessage = '';
  vm.searchString = '';
  vm.previousSearchString = '';
  vm.isAccountSelected = true;

  //Pagination
  vm.current = {
    equipsPage: 1,
  };
  vm.itemsPerPage = 8;
  vm.totalItems = 0;
  vm.predicate = 'name';
  vm.reverse = true;

  vm.getAccountsToShare = getAccountsToShare;
  vm.setPredicate = setPredicate;
  vm.displayEquipmentsByPage = displayEquipmentsByPage;
  vm.resetFlags = resetFlags;
  vm.openMultiAsstsModal = openMultiAsstsModal;
  vm.removeselectedEquips = removeselectedEquips;
  vm.shareEquipments = shareEquipments;
  vm.refreshSearch = refreshSearch;

  vm.$onInit = function () {
    vm.setPredicate(vm.predicate, true);
    vm.getAccountsToShare();
  };

  // Fill "Share To:" drop down
  function getAccountsToShare() {
    vm.loading = true;
    transfersService
      .getTransferKeysToShare()
      .then(function (response) {
        let shareKeys = response.data || [];
        vm.accounts = buildAccountDropdown(shareKeys);
      }, handleError)
      .finally(function () {
        vm.loading = false;
      });
  }

  // rest messages flages
  function resetFlags() {
    vm.successFlag = false;
    vm.errorFlag = false;
    vm.isAccountSelected = true;
  }

  // open multi assets picker
  function openMultiAsstsModal() {
    vm.resetFlags();
    let modalInstance = $uibModal.open({
      template: multiPickerTemplate,
      controller: 'AssetMultiPickerController',
      size: 'lg',
      resolve: {
        prefilter: () => ({
          queries: ['NOT onei3:share:from:*'],
        }),
        singleSelect: false,
        requiresSelection: true,
        maxSelection: function () {
          return 50;
        },
        selectedAssets: function () {
          let selected = {};
          if (vm.equipments) {
            for (let i = 0; i < vm.equipments.length; i++) {
              let e = vm.equipments[i];
              selected[e.id] = e;
            }
          }
          return selected;
        },
      },
    });

    // handel the modals return
    modalInstance.result.then(function (selectedAssets) {
      vm.equipments = [];
      for (let key in selectedAssets.result) {
        vm.equipments.push(selectedAssets.result[key]);
      }
      refreshTable();
      GTM_ListChanged('shareToAssetsSelectionChanged');
    });
  } // end openMultiAsset

  function removeselectedEquips(equip) {
    let newEquipList = [];
    angular.forEach(vm.equipments, function (equipment, key) {
      if (equip !== equipment.id) {
        newEquipList.push(equipment);
      }
    });

    vm.equipments = newEquipList.slice();
    refreshTable();
    GTM_ListChanged('shareToAssetRemoved');
  }

  //  post the equipments to share api
  function shareEquipments(account) {
    if (!account) {
      vm.isAccountSelected = false;
      return;
    }
    let hrefResources = getEquipsHrefResource();

    if (!vm.postingData) {
      vm.postingData = true;
      transfersService
        .postEquipmentToShare(account, {
          action: 'share',
          resources: hrefResources,
        })
        .then(function (result) {
          vm.equipments = [];
          refreshTable();
          vm.successFlag = true;
          vm.postingData = false;
        }, handleErrorForShare);
    }
  }

  function handleErrorForShare(error) {
    let errorMsg = gettextCatalog.getString('An error occurred when sharing Assets');
      if (error.data)
        errorMsg +=  getEquipsFromHrefResource(error.data);
      else
      errorMsg += gettextCatalog.getString('. Please try again later.');
    vm.equipments = [];
    refreshTable();
    vm.errorText = errorMsg;
    vm.errorFlag = true;
    vm.postingData = false;
  }


  // get url for equipment
  function getEquipsHrefResource() {
    let equipsHrefResource = [];
    vm.equipments.forEach((equipment) => {
      equipsHrefResource.push(transfersService.getResourceUrl() + equipment.id);
    });
    return equipsHrefResource;
  }

  // get equipment from  url
  function getEquipsFromHrefResource(hrefsConcatinated) {
    let equipsIds=" ";
    let hrefs = hrefsConcatinated.split(',');
    hrefs.forEach((href) => {
      href = href.replace(transfersService.getResourceUrl(), " ");
      href= href.trim();
      equipsIds += " " + (vm.equipments.find(x => x.id == href).name);
    });
    return equipsIds;
  }

  // Sort column ascending or descending
  function setPredicate(predicate, loading = false) {
    vm.reverse = vm.predicate === predicate ? !vm.reverse : false;
    vm.predicate = predicate;
    if (!loading) GTM_ListChanged('shareToAssetsOrderChanged');
  }

  function displayEquipmentsByPage() {
    vm.totalItems = vm.equipments.length;
    let begin = (vm.current.equipsPage - 1) * vm.itemsPerPage;
    let end = begin + vm.itemsPerPage;
    vm.equipmentsByPage = vm.filteredEquipments.slice(begin, end);
  }

  // submit search bar string
  function refreshSearch() {
    if (vm.previousSearchString === vm.searchString) return;
    vm.filteredEquipments = $filter('filter')(vm.equipments, vm.searchString);
    vm.previousSearchString = vm.searchString;
    vm.displayEquipmentsByPage();
    GTM_ListChanged('shareToAssetsFiltered');
  }

  //can call this after updating $scope.equipments to reflect changes on the table
  function refreshTable() {
    vm.filteredEquipments = $filter('filter')(vm.equipments, vm.searchString);
    vm.displayEquipmentsByPage();
  }

  function handleError(error) {
    let errorMsg = gettextCatalog.getString('An error occurred when loading Accounts');
    if (error.data || error.status) {
      if (error.data.message) {
        errorMsg = `${
          error.data.message
        } (${error.status.toString()} - ${error.statusText.toString()})`;
      } else {
        errorMsg += `: (${error.status.toString()} - ${error.statusText.toString()})`;
      }
    } else {
      errorMsg += gettextCatalog.getString('. Please try again later.');
    }
    vm.accounts = [];
    vm.errorText = errorMsg;
    vm.errorFlag = true;
  }

  function buildAccountDropdown(shareKeys = []) {
    let accountArray = [];
    shareKeys.forEach(function (shareKey) {
      if (shareKey.attrs && shareKey.attrs.name) {
        accountArray.push({
          key: shareKey.key,
          name: shareKey.account + ' - ' + shareKey.attrs.name,
        });
      } else {
        accountArray.push({
          key: shareKey.key,
          name: shareKey.account,
        });
      }
    });
    let accounts = $filter('orderBy')(accountArray, 'name', false); // sort the acccount in dropdown by account name
    vm.accountMessage =
      accounts.length === 0
        ? gettextCatalog.getString('No accounts available to share to')
        : gettextCatalog.getString('Select Account...');
    return accounts;
  }

  vm.accountChanged = function () {
    vm.resetFlags();

    window.dataLayer.push({
      event: 'shareToAccountChanged',
    });
  };

  vm.pageChanged = function () {
    GTM_ListChanged('shareToAssetsPageChanged');
  };

  function GTM_ListChanged(event) {
    window.dataLayer.push({
      event: event,
      data: {
        total: vm.equipments.length,
        totalFiltered: vm.filteredEquipments.length,
        pageNumber: vm.current.equipsPage,
        orderBy: vm.predicate,
        sorDirection: vm.reverse ? 'descending' : 'ascending',
      },
    });
  }
} // end controller
